import React from 'react'
import './Entertainment.css';
import '../Progressivecommon.css';
import img1 from '../assetsprogressive/progressive1.png';

export default function EntertainmentProgressive() {
  return (
    <div id='entertainment-progressive' className="progressive-wrapper">
      <span>For HNIs & UHNIs</span>
      <h1 className='h1-tag'>Your journey into entertainment debt assets simplified</h1>
      <div className="cards">
        <div className="card">
            <img src={img1} alt="error" />
            <h2>Diversify your portfolio</h2>
            <p>Participate in our non-market linked opportunities. Spread your portfolio across movies, not just the usual stuff</p>
        </div>
           <div className="card">
            <img src={img1} alt="error" />
            <h2>Clear Visibility</h2>
            <p>Risk mitigated and backed by confirmed future cash flows from leading OTT platforms, TV Channels & YouTube stars</p>
        </div>
           <div className="card">
            <img src={img1} alt="error" />
            <h2>Better Returns</h2>
            <p>Our experts pick projects with high earning potential, maximising your gains</p>
        </div>
           <div className="card">
            <img src={img1} alt="error" />
            <h2>Industry-Leading Expertise</h2>
            <p>Team of finance experts with extensive media industry experience evaluate opportunities 5-level robust framework</p>
        </div>
           <div className="card">
            <img src={img1} alt="error" />
            <h2>Early & Exclusive</h2>
            <p>Be the first to be a part of top tier risk mitigated entertainment assets and at ease, only via BetterInvest</p>
        </div>
<div class="card-wrapper">

        <div class="maincard">
             <div class="cutout"></div>
            <div class="inverted-top-right"></div>
            <div class="inverted-bottom-left"></div>
            <div class="card-content">
                <h2>Ready to earn and see your money grow faster?</h2>
            </div>
            <div class="button-container">
                <button class="explore-btn">
                    EXPLORE NOW
                    <span class="arrow">→</span>
                </button>
            </div>
        </div>
    </div>
      </div>
        </div>
  )
}
